import { useContext, useEffect } from "react";
import {
  Modal,
  ModalBody,
  Badge,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Alert,
  Form,
  FormGroup,
} from "reactstrap";
import { isEmpty } from "lodash";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Icon from "../../../components/Icon/Icon";
import PaginationComponent from "../../../components/Pagination/Pagination";
import TableFilter from "../../../components/TableFilter/TableFilter";
import PageHeader from "../../../components/PageHeader/PageHeader";
import SearchTable from "../../../components/SearchTable/SearchTable";
import InfoItem from "../../../helpers/InfoItem/InfoItem";
import UserAvatar from "../../../components/UserAvatar/UserAvatar";
import UserInfoItem from "../../../components/UserInfoItem/UserInfoItem";
import Button from "../../../components/Button/Button";
import ErrorMessage from "./../../../helpers/ErrorMessage/ErrorMessage";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import { Block } from "../../../components/Block/Block";
import { Col, Row } from "../../../components/Grid/Grid";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "../../../components/DataTable/DataTable";
import { flyOrderUserContext } from "./../../../context/UserContext/FlyOrderUserContext/FlyOrderUserContext";
import { convertDate, convertRoleToText, numberSeparate } from "../../../utils";
import {
  convertCharter724AirlineToText,
  convertCharter724PassengerTypeToText,
  convertFlyOrderStatusToColor,
  convertFlyOrderStatusToText,
  flyOrderStatusItems,
} from "../../../utils/enum";
import { yupResolver } from "@hookform/resolvers/yup";
import { changeFlyOrderStatusValidation } from "../../../utils/validation/validation";
import { base_url } from "../../../services/configServices/config";

const FlyOrdersUser = () => {
  const loader = useSelector((state) => state.loader);
  const auth = useSelector((state) => state.auth);

  const {
    flyOrders,
    flyOrder,
    setFlyOrder,
    filter,
    setFilter,
    sort,
    setSort,
    start,
    setStart,
    end,
    setEnd,
    pageCount,
    itemsCount,
    setItemsCount,
    pageNumber,
    setPageNumber,
    handleGetFlyOrders,
    handleChangeFlyOrderStatus,
    handleBuyTicket,
    handleUploadFile,
  } = useContext(flyOrderUserContext);

  useEffect(() => {
    handleGetFlyOrders();
  }, [start, end, pageNumber, itemsCount, sort]);

  // Validation
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(changeFlyOrderStatusValidation),
  });

  useEffect(() => {
    if (flyOrder.isChangedStatus) reset();
  }, [flyOrder]);

  return (
    <>
      <SiteTitle title="سفارشات پرواز" />

      <PageHeader title="سفارشات پرواز" />

      <TableFilter
        setItemsCount={setItemsCount}
        itemsCount={itemsCount}
        setSort={setSort}
        sort={sort}
        setStart={setStart}
        start={start}
        setEnd={setEnd}
        end={end}
      />

      <Block>
        <DataTable className="card-stretch">
          <SearchTable
            filterPlaceholder="شناسه درخواست و ..."
            filter={filter}
            setFilter={setFilter}
            onSearch={handleGetFlyOrders}
          />
          <DataTableBody>
            <DataTableHead>
              <DataTableRow>
                <span className="sub-text">#</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">مبدا</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">مقصد</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">کاربر</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">شناسه درخواست</span>
              </DataTableRow>
              <DataTableRow size="sm">
                <span className="sub-text">تاریخ پرواز</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">وضعیت</span>
              </DataTableRow>
              <DataTableRow />
            </DataTableHead>
            {/*Head*/}
            {flyOrders.length > 0
              ? flyOrders.map((item, index) => {
                  return (
                    <DataTableItem key={item._id}>
                      <DataTableRow>
                        <span>{index + 1}</span>
                      </DataTableRow>
                      <DataTableRow>{item.to_flight}</DataTableRow>
                      <DataTableRow>{item.from_flight}</DataTableRow>
                      <DataTableRow size="md">
                        {isEmpty(item?.user) ? (
                          "کاربر عادی"
                        ) : (
                          <div className="user-card">
                            <UserAvatar
                              {...(item?.user?.avatar
                                ? { image: item?.user?.avatar }
                                : {
                                    icon: "user-alt",
                                  })}
                            />
                            <UserInfoItem
                              title={`${item?.user?.firstName} ${item?.user?.lastName}`}
                              subTitle={item?.user?.phoneNumber}
                            />
                          </div>
                        )}
                      </DataTableRow>
                      <DataTableRow size="lg">
                        <span>{item.id_request}</span>
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <span>
                          {convertDate(item.date_flight)} {item.time_flight}
                        </span>
                      </DataTableRow>

                      <DataTableRow>
                        <Badge
                          color={convertFlyOrderStatusToColor(item.status)}
                          className="badge-dim"
                        >
                          {convertFlyOrderStatusToText(item.status)}
                        </Badge>
                      </DataTableRow>

                      <DataTableRow className="nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1">
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag="a"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                              >
                                <Icon name="more-h" />
                              </DropdownToggle>
                              <DropdownMenu
                                left
                                className="dropdown_max_height"
                              >
                                <ul className="link-list-opt no-bdr text-right">
                                  <li
                                    onClick={() => {
                                      setFlyOrder(item);
                                    }}
                                  >
                                    <DropdownItem tag="a" type="button">
                                      <Icon name="eye" />
                                      <span>جزئیات</span>
                                    </DropdownItem>
                                  </li>
                                  {auth.isAdmin &&
                                    item.status === flyOrderStatusItems[4] && (
                                      <>
                                        <li
                                          onClick={() => {
                                            setFlyOrder({
                                              ...item,
                                              isChangedStatus: true,
                                            });
                                          }}
                                        >
                                          <DropdownItem tag="a" type="button">
                                            <Icon name="edit" />
                                            <span>تغییر وضعیت</span>
                                          </DropdownItem>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleBuyTicket(
                                              item.id_request,
                                              item.id_faktor
                                            );
                                          }}
                                        >
                                          <DropdownItem tag="a" type="button">
                                            <Icon name="check" />
                                            <span>تایید سیستمی سفارش</span>
                                          </DropdownItem>
                                        </li>
                                      </>
                                    )}
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </DataTableRow>
                    </DataTableItem>
                  );
                })
              : null}
          </DataTableBody>
          <div className="card-inner">
            {flyOrders.length > 0 ? (
              <PaginationComponent
                pageCount={pageCount}
                currentPage={pageNumber}
                setPageNumber={setPageNumber}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">داده ای برای نمایش یافت نشد</span>
              </div>
            )}
          </div>
        </DataTable>
      </Block>

      <Modal
        isOpen={!isEmpty(flyOrder) && !flyOrder.isChangedStatus}
        toggle={() => setFlyOrder({})}
        className="modal-dialog-centered"
        size="md"
      >
        <ModalBody>
          <span type="button" onClick={() => setFlyOrder({})} className="close">
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">جزئیات سفارش {flyOrder.fly_name}</h5>
            <br />
            {!isEmpty(flyOrder.user) && (
              <>
                <span className="text-primary border-bottom fw-bold">
                  اطلاعات کاربر
                </span>
                <Row>
                  <Col sm="6">
                    <InfoItem title="نام">{flyOrder.user?.firstName}</InfoItem>
                  </Col>
                  <Col sm="6">
                    <InfoItem title="نام خانوادگی">
                      {flyOrder.user?.lastName}
                    </InfoItem>
                  </Col>
                  <Col sm="6">
                    <InfoItem title="شماره تماس">
                      {flyOrder?.user?.phoneNumber}
                    </InfoItem>
                  </Col>
                  <Col sm="6">
                    <InfoItem title="نقش">
                      {convertRoleToText(flyOrder?.user?.role)}
                    </InfoItem>
                  </Col>
                  <Col sm="6">
                    <InfoItem title="وضعیت کاربر">
                      <Badge
                        className="badge-dim has-bg"
                        color={flyOrder?.user?.isActive ? "success" : "danger"}
                      >
                        {flyOrder?.user?.isActive ? "فعال" : "غیرفعال"}
                      </Badge>
                    </InfoItem>
                  </Col>
                </Row>
                <br />
              </>
            )}
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات سفارش
            </span>
            <Row>
              <Col sm="6">
                <InfoItem title="شناسه درخواست">{flyOrder.id_request}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="وضعیت">
                  <Badge
                    color={convertFlyOrderStatusToColor(flyOrder.status)}
                    className="badge-dim"
                  >
                    {convertFlyOrderStatusToText(flyOrder.status)}
                  </Badge>
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ ایجاد">
                  {convertDate(flyOrder.createdAt, "YYYY-MM-DD HH:mm")}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ ویرایش">
                  {convertDate(flyOrder.updatedAt, "YYYY-MM-DD HH:mm")}
                </InfoItem>
              </Col>
            </Row>
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات پرواز
            </span>
            <Row>
              <Col sm="6">
                <InfoItem title="مبدا">
                  <span>{flyOrder?.from_flight}</span>
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="مقصد">{flyOrder.to_flight}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="ایرلاین">
                  {convertCharter724AirlineToText(flyOrder.airline)}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="شماره پرواز">
                  {flyOrder.number_flight}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="ایمیل">{flyOrder.email}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="شماره موبایل">{flyOrder.mobile}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ پرواز">
                  {convertDate(flyOrder.date_flight, "YYYY-MM-DD")}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="ساعت پرواز">{flyOrder.time_flight}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ ایجاد">
                  {convertDate(flyOrder.createdAt, "YYYY-MM-DD HH:mm")}
                </InfoItem>
              </Col>
              {flyOrder.linkticket && (
                <Col sm="6">
                  <a
                    className="btn btn-info btn-block"
                    href={flyOrder.linkticket}
                    target="_blank"
                    rel="noreferrer"
                  >
                    دانلود بلیط
                  </a>
                </Col>
              )}
              <Col sm="12">
                <InfoItem title="پیغام سیستمی">{flyOrder?.msg}</InfoItem>
              </Col>
            </Row>
            {!isEmpty(flyOrder?.passenger_info) && (
              <>
                <br />
                <span className="text-primary border-bottom fw-bold">
                  اطلاعات {flyOrder?.passenger_info?.length} مسافر
                </span>
                {flyOrder?.passenger_info?.map((item) => (
                  <Row
                    key={item?._id}
                    className="border rounded mb-2 border-primary m-0"
                  >
                    <Col sm="6">
                      <InfoItem title="نام">{item?.fname}</InfoItem>
                    </Col>
                    <Col sm="6">
                      <InfoItem title="نام خانوادگی">{item?.lname}</InfoItem>
                    </Col>
                    <Col sm="6">
                      <InfoItem title="نوع مسافر">
                        {convertCharter724PassengerTypeToText(item?.type)}
                      </InfoItem>
                    </Col>
                    <Col sm="6">
                      <InfoItem title="شماره بلیط">
                        {item?.ticket_number}
                      </InfoItem>
                    </Col>
                  </Row>
                ))}
              </>
            )}
            {flyOrder?.totalprice_request && (
              <Alert color="info" className="text-center">
                قیمت نهایی:{" "}
                <ConvertCurrency
                  price={Math.floor(flyOrder?.totalprice_request / 10)}
                />{" "}
                <Currency />
              </Alert>
            )}
            {!isEmpty(flyOrder?.rooms) && (
              <>
                <br />
                <span className="text-primary border-bottom fw-bold">
                  اطلاعات اتاق ها
                </span>
                {flyOrder?.rooms?.map((item) => (
                  <Row
                    key={item?._id}
                    className="border rounded mb-2 border-primary m-0"
                  >
                    <Col sm="6">
                      <InfoItem title="نوع اتاق">{item?.title}</InfoItem>
                    </Col>
                    <Col sm="6">
                      <InfoItem title="قیمت نهایی">
                        <ConvertCurrency price={item?.final_price} />
                        <Currency />
                      </InfoItem>
                    </Col>
                    <Col sm="6">
                      <InfoItem title="تخت اضافه">
                        {numberSeparate(item?.extra_beds)}
                      </InfoItem>
                    </Col>
                    <Col sm="6">
                      <InfoItem title="قیمت تخت اضافه">
                        <ConvertCurrency price={item?.extra_bed_fee} />{" "}
                        <Currency />
                      </InfoItem>
                    </Col>
                    <Col size="12">
                      {!isEmpty(item?.guests) && (
                        <>
                          <br />
                          <span className="text-primary border-bottom fw-bold">
                            اطلاعات میهمانان
                          </span>
                          {item?.guests?.map((_item) => (
                            <Row
                              key={_item?._id}
                              className="border rounded mb-2 border-primary m-0"
                            >
                              <Col sm="6">
                                <InfoItem title="نام">
                                  {_item?.first_name}
                                </InfoItem>
                              </Col>
                              <Col sm="6">
                                <InfoItem title="نام خانوادگی">
                                  {_item?.last_name}
                                </InfoItem>
                              </Col>
                              <Col sm="6">
                                <InfoItem title="خارجی">
                                  <Icon
                                    name={_item?.foreigner ? "check" : "cross"}
                                    className={`text-${
                                      _item?.foreigner ? "success" : "danger"
                                    }`}
                                  />
                                </InfoItem>
                              </Col>
                              <Col sm="6">
                                <InfoItem title="نیم شارژ">
                                  <Icon
                                    name={_item?.is_extra ? "check" : "cross"}
                                    className={`text-${
                                      _item?.is_extra ? "success" : "danger"
                                    }`}
                                  />
                                </InfoItem>
                              </Col>
                            </Row>
                          ))}
                        </>
                      )}
                    </Col>
                  </Row>
                ))}
              </>
            )}
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={!isEmpty(flyOrder) && flyOrder.isChangedStatus}
        toggle={() => setFlyOrder({})}
        className="modal-dialog-centered"
        size="md"
      >
        <ModalBody>
          <span type="button" onClick={() => setFlyOrder({})} className="close">
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">ویرایش سفارش {flyOrder.fly_name}</h5>
            <br />

            <Form
              className="is-alter"
              onSubmit={handleSubmit(handleChangeFlyOrderStatus)}
            >
              <Row className="gy-4">
                <Col size="12">
                  <FormGroup>
                    <label className="form-label" htmlFor="status">
                      وضعیت
                    </label>
                    <div className="form-control-wrap">
                      <select
                        className="form-control-lg form-control"
                        {...register("status")}
                      >
                        <option value="" selected hidden>
                          وضعیت سفارش را انتخاب نمایید
                        </option>
                        {[flyOrderStatusItems[5], flyOrderStatusItems[6]].map(
                          (item) => (
                            <option
                              key={item}
                              value={item}
                              selected={item === watch("status")}
                            >
                              {convertFlyOrderStatusToText(item)}
                            </option>
                          )
                        )}
                      </select>
                      <ErrorMessage message={errors.status?.message} />
                    </div>
                  </FormGroup>
                </Col>
                {watch("status") === flyOrderStatusItems[5] && (
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label" htmlFor="message">
                        فایل بلیط
                      </label>
                      <div className="form-control-wrap">
                        <label
                          htmlFor="ticketLink"
                          className="btn btn-info btn-block shadow"
                        >
                          {watch("ticketLink") || "انتخاب فایل بلیط"}

                          <input
                            type="file"
                            accept=".jpg,.jpeg,.png,.gif,.docx,.xlsx,.csv,.pdf,.mp4,.avi;capture=camera"
                            id="ticketLink"
                            className="d-none"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              handleUploadFile(file, (e) =>
                                setValue("ticketLink", `${base_url}${e}`)
                              );
                              document.getElementById(`ticketLink`).value = "";
                            }}
                          />
                        </label>
                      </div>
                    </FormGroup>
                  </Col>
                )}
                <Col size="12">
                  <FormGroup>
                    <label className="form-label" htmlFor="description">
                      توضیحات
                    </label>
                    <div className="form-control-wrap">
                      <textarea
                        placeholder="توضیحات را وارد نمایید"
                        className="form-control-lg form-control"
                        {...register("description")}
                      />
                      <ErrorMessage message={errors.description?.message} />
                    </div>
                  </FormGroup>
                </Col>
                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <li>
                      <Button
                        color="primary"
                        size="lg"
                        type="submit"
                        loading={loader}
                      >
                        ویرایش وضعیت
                      </Button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={() => setFlyOrder({})}
                        className="link link-light"
                      >
                        انصراف
                      </button>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Form>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default FlyOrdersUser;
